<div class="pt-3" [zeroLoadingIndicator]="ongoingRequest">
  @if (enrolledTANDevices) {
    @if (tanMode) {
      @if (!tanSuccessfullySent) {
        <div class="d-flex flex-column align-items-center">
          <p class="text-size-large text-center">
            @if (isTradingSessionAuth) {
              {{ 'transaction-authorization.session-auth' | transloco }}
            } @else {
              {{ 'transaction-authorization.transaction-auth' | transloco }}
            }
          </p>
          <div class="d-flex col-md-8 justify-content-center">
            <web-design-system-button size="small" data-zid="get-tan" (click)="initiateTanAuth()">
              {{ 'transaction-authorization.sms' | transloco }}
            </web-design-system-button>
            @if (ttsEnabled) {
              <web-design-system-button size="small" class="ml-1 ml-sm-3" (click)="initiateTanAuth(true)">
                {{ 'transaction-authorization.call' | transloco }}
              </web-design-system-button>
            }
          </div>
        </div>
      }
      @if (!!tanSuccessfullySent) {
        <div class="font-size-smaller1 text-align-center">
          @if (!lastTanWasTts) {
            {{
              'transaction-authorization.successfully-sent.sms'
                | transloco: { lastTanRequested: lastTanRequested | date: 'mediumTime', verifiedPhoneNumber }
            }}
          }
          @if (lastTanWasTts) {
            {{
              'transaction-authorization.successfully-sent.call'
                | transloco: { lastTanRequested: lastTanRequested | date: 'mediumTime', speechNr }
            }}
          }
        </div>
      }
      @if (!!tanSuccessfullySent) {
        <form #f="ngForm">
          @if (tanval.invalid || tanval.pristine || !tanSuccessfullySent || errors.length > 0) {
            <div class="row mt-1 justify-content-center">
              <div class="col-12 font-size-smaller1 text-align-center">
                @if (offerTanResend) {
                  {{ 'transaction-authorization.successfully-sent.invalid.hint' | transloco }}
                  <a class="link link-secondary font-size-smaller1 cursor-pointer" (click)="initiateTanAuth(lastTanWasTts, tanval)">
                    {{ 'transaction-authorization.successfully-sent.invalid.resend' | transloco }}
                  </a>
                }
                @if (!offerTanResend) {
                  {{ 'transaction-authorization.successfully-sent.invalid.waiting' | transloco }}
                }
              </div>
            </div>
          }
          <div class="row mt-4">
            <div class="col-md-6 col-12 mx-auto" [class.col-12]="!tanval.value || transactionCreated">
              <div class="input-group-material" [class.input-group-material--error]="tanval.touched && tanval.invalid">
                <input
                  type="text"
                  autocomplete="off"
                  data-zid="tan"
                  required
                  zeroAutofocus
                  pattern="[0-9]{6}"
                  id="taninput"
                  name="taninput"
                  ngModel
                  #tanval="ngModel"
                  #taninput
                  [class.empty]="!tanval.value"
                  maxlength="6"
                  (input)="tanInputValueChange()"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="taninput" [class.rised]="tanval.value">
                  {{ 'transaction-authorization.form.tan' | transloco }}
                </label>
                @if (tanval.touched && tanval.invalid) {
                  <div class="input-group-material-message">
                    {{ 'transaction-authorization.form.invalid' | transloco }}
                  </div>
                }
              </div>
            </div>
            @if (tanval.value && !transactionCreated) {
              <div class="col-12 d-flex justify-content-center mt-2">
                <web-design-system-button
                  type="primary"
                  size="small"
                  data-zid="check-tan"
                  (click)="createTransaction(tanval.value)"
                  [disabled]="f.invalid"
                >
                  {{ 'transaction-authorization.form.btn' | transloco }}
                </web-design-system-button>
              </div>
            }
          </div>
        </form>
      }

      @if (appAuthEnabled) {
        <p class="mt-3 text-center text-size-large" [innerHTML]="'transaction-authorization.hint' | transloco"></p>
      }
    }
    @if (appMode) {
      <div class="d-flex flex-column align-items-center">
        @if (!transactionAbortedThroughApp && !transactionCreated) {
          @if (enrolledTANDevices.length > 1) {
            <div class="pr-5">
              <div
                class="input-group-material select-dropdown dropdown-authdevices mt-3"
                [class.input-group-material--error]="chooseDeviceVar.invalid && chooseDeviceVar.touched"
              >
                <select
                  [(ngModel)]="chosenTANDeviceName"
                  name="chooseDeviceSelect"
                  id="chooseDeviceSelect"
                  (ngModelChange)="initiateAppAuth()"
                  #chooseDeviceVar="ngModel"
                  [class.empty]="!chooseDeviceVar.value"
                  required
                >
                  @for (device of enrolledTANDevices; track device.serial) {
                    <option [value]="device.customerDeviceName">
                      {{ device.customerDeviceName }}
                    </option>
                  }
                </select>
                <label for="chooseDeviceSelect" class="text-no-wrap">
                  {{ 'transaction-authorization.app-mode.choice' | transloco }}
                </label>
                @if (!chooseDeviceVar.value || chooseDeviceVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
              </div>
            </div>
          }
        }
        @if (waitingForTransactionAuth) {
          <div>
            <p class="mb-0 text-center" [innerHTML]="(isTradingSessionAuth ? '' : '') | transloco: { chosenTANDeviceName }"></p>
          </div>
        }
        @if (transactionAbortedThroughApp) {
          <div class="d-flex justify-content-center">
            @if (!isTradingSessionAuth) {
              {{ 'transaction-authorization.app-mode.aborted.transaction' | transloco }}
            }
            @if (isTradingSessionAuth) {
              {{ 'transaction-authorization.app-mode.aborted.session' | transloco }}
            }
          </div>
        }
        @if (!transactionAbortedThroughApp && !transactionCreated) {
          <div class="font-size-smaller2">
            <a class="link link-underline link-primary cursor-pointer" (click)="switchToTanMode()">
              {{ 'transaction-authorization.app-mode.aborted.change' | transloco }}
            </a>
          </div>
        }
      </div>
    }
    @if (transactionCreated) {
      <p class="text-center">
        @if (isTradingSessionAuth) {
          {{ 'transaction-authorization.app-mode.success.session' | transloco }}
        }
        @if (!isTradingSessionAuth) {
          {{ 'transaction-authorization.app-mode.success.transaction' | transloco }}
        }
      </p>
    }
    @if (!transactionCreated) {
      <div class="mt-3 d-flex justify-content-center">
        <a class="link-secondary font-size-smaller2 cursor-pointer" data-zid="cancel-auth" (click)="cancelAuth()">
          {{ 'transaction-authorization.app-mode.cancel' | transloco }}
        </a>
      </div>
    }
  }
  <div class="mt-2">
    @for (msg of errors; track $index) {
      <p class="text-color-error text-center">{{ msg }}</p>
    }
  </div>
</div>
